import { Ref } from "react";
import QuestionSubForm from "./QuestionSubForm";
import { Virtuoso, VirtuosoHandle } from "react-virtuoso";
import { Question } from "@/types/question";
import Empty from "@/components/Empty";
import SurveyConfiguration from "./SurveyConfiguration";
import AddQuestionButton from "./Toolbar/components/AddQuestionButton";
import { useTranslation } from "react-i18next";

interface QuestionListProps {
  fields: Question[];
  listRef: Ref<VirtuosoHandle>;
  interQuestionToolbar?: (index: number) => React.ReactNode;
  hint?: string;
}

function Header({ context }: { context: { fields: Question[] } }) {
  const { t } = useTranslation();
  const { fields } = context;
  return (
    <>
      <SurveyConfiguration className="mb-4" />
      <Empty
        when={fields !== undefined && fields.length === 0}
        action={
          <AddQuestionButton
            variant="default"
            data-testid="empty-survey-add-question"
          />
        }
      >
        {t("surveyEditor.emptySurvey")}
      </Empty>
    </>
  );
}

export default function QuestionList({
  fields,
  listRef,
  interQuestionToolbar,
  hint,
}: QuestionListProps) {
  // TODO: Replace Virtuoso with @tanstack/react-virtual
  return (
    <Virtuoso
      components={{
        Header,
      }}
      context={{ fields }}
      className="p-0 list-none flex flex-col mb-12 h-full"
      totalCount={fields.length}
      data={fields}
      computeItemKey={(index, item) => {
        return `item-${item.id}`;
      }}
      ref={listRef}
      itemContent={(index, field) => (
        <QuestionSubForm
          index={index}
          type={field.type}
          isFirst={index === 0}
          isLast={index === fields.length - 1}
          toolbar={interQuestionToolbar?.(index)}
          hint={hint}
        />
      )}
    />
  );
}
